import React from 'react';
import '../CSS/InputHeader.css';

const InputHeader = () => (
  <h2 className="add-book">ADD NEW BOOK</h2>
);

export default InputHeader;
